module.exports = __webpack_public_path__ + "media/src/assets/Images/CarruselMobileLeft-7849a46be0145ef3adafeb5bf7f8f0ea.svg";